import { useEffect, useState } from "react";
import { getOrganizationAdmins } from "../../dataApi/organizations";

export const useOrgAdmins = (listId: string) => {
  const [admins, setAdmins] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      setLoading(true);
      const data = await getOrganizationAdmins(listId);
      setAdmins(data);
      setLoading(false);
    })();
  }, []);
  return { admins, loading };
};
